import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../../../General/Text';
import { ContainerStyled, TextStyled } from './style/HeaderStyled';
import IconDatos from '../../../../../images/bolsas/tipos/datos.svg';
import IconIlimitada from '../../../../../images/bolsas/tipos/ilimitada.svg';
import IconMixta from '../../../../../images/bolsas/tipos/mixta.svg';
import IconRoaming from '../../../../../images/bolsas/tipos/roaming.svg';
import IconVoz from '../../../../../images/bolsas/tipos/voz.svg';
import RechargeIcon from '../../../../../images/mis-otras-lineas/RechargeWhiteIcon.svg';
import useOtherLines from '../../../../../hooks/useOtherLines';

const icons = {
  2: IconDatos,
  3: IconMixta,
  4: IconIlimitada,
  5: IconRoaming,
  6: IconVoz,
};

const Header = ({ name, description, code }) => {
  const { actionType } = useOtherLines();
  return (
    <ContainerStyled>
      <div>
        {icons[code] ? (
          <img src={icons[code]} alt="Icono Bolsa" />
        ) : (
          <img
            src={actionType === 'recarga' ? RechargeIcon : IconDatos}
            alt="Icono Bolsa"
            data-testid="default-icon"
          />
        )}
      </div>

      {actionType === 'recarga' ? (
        <TextStyled recarga>
          <Text
            text="Recargar Saldo"
            color="#FFFFFF"
            size="20px"
            weight="600"
          />
        </TextStyled>
      ) : (
        <TextStyled>
          <Text text={name} color="#FFFFFF" size="18px" weight="600" />
          <Text text={description} color="#FFFFFF" size="14px" weight="400" />
        </TextStyled>
      )}
    </ContainerStyled>
  );
};

Header.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  code: PropTypes.string,
};

Header.defaultProps = {
  name: '',
  description: '',
  code: '',
};

export default Header;
